export const ZUS_SIGN_STATUS_LABELS = {
  ERROR: 'Przesyłka nieprzyjęta do ZUS',
  WAIT_PACKAGE: 'Przesyłka wysłana do ZUS. Odśwież status',
  WAIT: 'Przesyłka wysłana do ZUS',
  NOSTATUS_PACKAGE: 'Przesyłka nie wysłana do ZUS',
  NOSTATUS: 'Nie dołączono do zestawu',
  SUCCESS: 'Przesyłka przyjęta do ZUS',
  CONTROL_PACKAGE: 'Przesyłka przyjęta do kontroli. Odśwież status',
  CONTROL: 'Przesyłka przyjęta do kontroli',
  INVESTIGATION_PACKAGE: 'Przesyłka przyjęta do wyjaśnienia',
  ERROR_PACKAGE: 'Problem z przesyłką',
  ADDED: 'Dołączono do zestawu',
};

export const ZUS_SIGN_STATUS_VALUES = {
  ERROR: 'Przesyłka nieprzyjęta do ZUS',
  WAIT: 'wait',
  NOSTATUS: 'nostatus',
  SUCCESS: 'Przesyłka przyjęta do ZUS',
  CONTROL: 'Przesyłka przyjęta do kontroli',
  INVESTIGATION: 'Przesyłka przyjęta do wyjaśnienia',
  ERROR_PACKAGE: 'Problem z przesyłką',
  ADDED: 'added',
};

export default {
  DRA_TYPE: 'DRA',
  RSA_TYPE: 'RSA',
  RPA_TYPE: 'RPA',
  RCA_TYPE: 'RCA',
};
